export default __webpack_public_path__ + "static/media/icon-Dale03.d835c11c.svg";